<template>
  <div class="pos-detail">
    <!-- permision -->
    <div v-if="dataPermission && dataPermission.includes('NSH_ORDER_VIEW')">
      <div v-if="orderData.lineItem && orderData.lineItem.length > 0">
        <Header>
          <template v-slot:header-right v-if="!(isSOFromReturn && orderData.orderStatus == 'DRAFT')">
            <template v-if="step == 0">
              <el-button plain type="danger" @click="cancelOrder" v-if="dataPermission && dataPermission.includes('NSH_ORDER_CANCEL')">Hủy đơn</el-button>
              <el-button type="primary" @click="continueOrder" v-if="dataPermission && dataPermission.includes('NSH_ORDER_UPDATE') && !isOrderFormOnlineStore"
                >Tiếp tục bán</el-button
              >
            </template>
            <!-- GHTT -->
            <template v-if="step == 1 && isOrderFormOnlineStore && !isOrderOnlineHasDlo">
              <el-button plain v-if="!isPayed && !isExportOrder && dataPermission && dataPermission.includes('NSH_ORDER_CANCEL')" class="mx-1 n-btn" type="danger" @click="cancelOrder">Hủy đơn</el-button>
              <el-button v-if="!isPayed" class="mx-1 n-btn" plain type="primary" @click="handleShowConfirmPayment">Xác nhận thanh toán</el-button>
              <el-button v-if="!isExportOrder" class="mx-1 n-btn" type="primary" @click="showExportOrder = true">Xác nhận đơn</el-button>
            </template>
            <!-- DLO -->
            <template v-if="step == 1 && isDLO && isOrderOnlineHasDlo">
              <template v-if="orderData.deliveryData.params.deliveryStatus == 'NEW' && !isDLOdone">
                <el-button type="danger" plain @click="showOrderDLOCancelAndDoNothing = true" v-if="dataPermission && dataPermission.includes('NSH_ORDER_CANCEL')">Hủy đơn</el-button>
                <el-button v-if="!isDLOdone && isNotCODpayment" @click="handleShowConfirmPayment" type="primary" plain>Xác nhận thanh toán</el-button>
                <el-button v-if="isDELIVERY_PARTNER && !isPushedToPartner" @click="deliveryToPartner" type="primary">Đẩy đơn qua hãng</el-button>
                <el-button v-else @click="showDeliveryAllDone = true" type="primary">Giao hàng thành công</el-button>
              </template>
              <template v-if="orderData.deliveryData.params.deliveryStatus == 'PROCESSING'">
                <el-button type="danger" plain @click="checkOderFromPartner('showPopupCancelAll')" v-if="dataPermission && dataPermission.includes('NSH_ORDER_CANCEL')">Hủy đơn</el-button>
                <!-- <el-dropdown class="mr-2 custom_btn__">
                    <el-button plain><i class="el-icon-arrow-down el-icon--left"></i>Hủy giao hàng</el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="showPopupCancelAndRenew = true">Huỷ giao & tạo đơn giao hàng mới</el-dropdown-item>
                      <el-dropdown-item class="text-danger" @click.native="showPopupCancelAll = true">Huỷ giao & huỷ đơn hàng</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->
                <el-button v-if="!isDLOdone && isNotCODpayment" @click="handleShowConfirmPayment" type="primary" plain>Xác nhận thanh toán</el-button>
                <el-button @click="showDeliveryDone = true" type="primary">Giao hàng thành công</el-button>
              </template>
              <template v-if="orderData.deliveryData.params.deliveryStatus == 'COMPLETE'">
                <!-- <el-button type="danger" plain @click="showPopupCancelAll = true">Hủy đơn</el-button> -->
                <el-button v-if="!isDLOdone && isNotCODpayment" @click="handleShowConfirmPayment" type="primary" plain>Xác nhận thanh toán</el-button>
              </template>
            </template>
            <template v-if="step == 3 && status === 'SUCCESS'">
              <el-button :disabled="!isReturnAble" plain type="danger" @click="ReturnAllItems" v-if="dataPermission && dataPermission.includes('NSH_ORDER_CANCEL')">Hủy đơn</el-button>
              <el-button plain type="primary" :disabled="!isReturnAble" @click="addNewReturn">Trả hàng</el-button>
              <el-button type="primary" @click="printBill">In hóa đơn</el-button>
            </template>
          </template>
        </Header>

        <!-- body -->
        <div class="pos-detail_body form_card_custom">
          <!-- steps -->
          <div class="container">
            <div class="top-steps">
              <el-steps :active="step" align-center>
                <el-step v-for="(step, i) in stepsArr" :key="i" :title="step.name" :description="step.description" :class="step.class ? step.class : ''"></el-step>
              </el-steps>
            </div>

            <!-- Thông tin đơn hàng -->
            <b-card class="form-card">
              <div class="form-card_title my-2">Thông tin đơn hàng</div>
              <div class="row my-4">
                <div class="col-2 text-right sub_title">Mã đơn hàng:</div>
                <div class="col-4">{{ orderData.orderNo }}</div>
                <div class="col-2 text-right sub_title">Thiết bị:</div>
                <div class="col-4">{{ targetMethodName[orderData.targetMethod] }}</div>
              </div>
              <div class="row my-4">
                <div class="col-2 text-right sub_title">Thời gian tạo:</div>
                <div class="col-4">{{ timeFormatStatus(orderData.createdAt) }}</div>
                <div class="col-2 text-right sub_title">Cập nhật lần cuối:</div>
                <div class="col-4">{{ timeFormatStatus(orderData.updatedAt) }}</div>
              </div>
              <div class="row my-4">
                <div class="col-2 text-right sub_title">Chi nhánh:</div>
                <div class="col-4">{{ branch | formatLocation }}</div>
                <div class="col-2 text-right sub_title">NV bán hàng:</div>
                <div class="col-4">{{ orderData.partyA.displayName }}</div>
              </div>

              <template v-if="isDLO">
                <div class="row my-4 align-items-center">
                  <div class="col-2 text-right sub_title">Giao hàng:</div>
                  <div>
                    <StatusBox
                      :status="getDeliveryStatus(orderData.deliveryData.params.deliveryStatus, orderData).status"
                      :showText="getDeliveryStatus(orderData.deliveryData.params.deliveryStatus, orderData).text"
                    ></StatusBox>
                    <!-- <StatusBox :status="orderData.deliveryData.params ? orderData.deliveryData.params.deliveryStatus : null"></StatusBox> -->
                  </div>
                  <a @click.prevent="$refs.deliveryInfo.scrollIntoView({ behavior: 'smooth', block: 'center' })" class="cursor col-4 text-primary d-flex">
                    <img class="mr-1" width="12px" height="12px" src="@assets/order-icon/arrow-down.svg" alt="arrow-down" />
                    <b>Xem thông tin giao hàng</b>
                  </a>
                </div>
                <div class="row my-4 align-items-center">
                  <div class="col-2 text-right sub_title">Thanh toán:</div>
                  <div>
                    <StatusBox
                      :status="getPaymentsStatus(orderData.deliveryData.params.paymentStatus).status"
                      :showText="getPaymentsStatus(orderData.deliveryData.params.paymentStatus).text"
                    ></StatusBox>
                  </div>
                  <a @click.prevent="$refs.paymentInfo.scrollIntoView({ behavior: 'smooth', block: 'center' })" class="cursor col-4 text-primary d-flex">
                    <img class="mr-1" width="12px" height="12px" src="@assets/order-icon/arrow-down.svg" alt="arrow-down" />
                    <b>Xem thông tin thanh toán</b>
                  </a>
                </div>
              </template>

              <div class="row my-4">
                <div class="col-2 text-right sub_title">Ghi chú:</div>
                <div class="col-10">{{ orderData.note | formatInformation }}</div>
              </div>
            </b-card>

            <!-- khách hàng -->
            <b-card class="form-card">
              <div class="d-flex justify-content-between align-items-center">
                <div class="form-card_title">
                  khách hàng
                </div>
                <div v-if="step == 1 && !isExportOrder && !isPayed && !isDLO">
                  <el-button @click="showChangeCustomer = true">Thay đổi thông tin</el-button>
                </div>
              </div>
              <div class="row my-4">
                <div class="col-2 text-right sub_title">Họ và tên:</div>
                <div class="col-10 d-flex">
                  {{ orderData.partyB.displayName }}
                  <router-link
                    v-if="orderData.partyB.resId"
                    :to="`/customer-list/customer-detail/${orderData.partyB.resId}`"
                    class="text-primary cusor ml-2 d-flex align-items-center"
                  >
                    <img class="mr-1" width="12px" height="12px" src="@assets/order-icon/arrow-detail.svg" alt="arrow-down" />
                    <div class="text-bold">
                      Chi tiết khách hàng
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="row my-4">
                <div class="col-2 text-right sub_title">Điện thoại:</div>
                <div class="col-4">{{ orderData.partyB.phoneNo | formatInformation }}</div>
                <div class="col-2 text-right sub_title">Email:</div>
                <div class="col-4">{{ orderData.partyB.email | formatInformation }}</div>
              </div>
              <div class="row my-4">
                <div class="col-2 text-right sub_title">Địa chỉ:</div>
                <div class="col-10">{{ orderData.partyB.address | formatInformation }}</div>
              </div>
            </b-card>

            <!-- not DLO -->
            <template v-if="!isDLO">
              <!-- <template v-if="true"> -->
              <!-- thông tin giao hàng -->
              <b-card class="form-card" v-if="step == 1 && isOrderFormOnlineStore && !isExportOrder">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="form-card_title">
                    Thông tin giao hàng
                  </div>
                  <div>
                    <DiliveryPos
                      disabledFeeShip
                      @new-dlo-info="createNewDlo"
                      v-if="showDeliveryModal"
                      :modalDilivery="showDeliveryModal"
                      @clickModalDiliveryHide="showDeliveryModal = false"
                      :dloData="dloInfoTmp"
                    />
                    <el-button type="primary" @click="handleCreateNewDloFromGHTT">Tạo đơn giao hàng</el-button>
                  </div>
                </div>
                <div class="w-100 my-5 text-center">
                  <img class="" src="@assets/order-icon/delivery-truck.svg" alt="arrow-down" />
                  <div class="text-secondary">Chưa có đơn giao hàng</div>
                </div>
              </b-card>

              <!-- Thông tin mua hàng -->
              <b-card class="form-card" v-if="status === 'CANCELED' || step == 0">
                <!-- <b-card class="form-card" v-if="step != 1"> -->
                <div class="form-card_title my-2">Thông tin mua hàng</div>
                <OrderInformationTableShowOnly :lineItem="lineItemMerge"></OrderInformationTableShowOnly>
              </b-card>

              <!-- Thông tin mua hàng có chỉnh sửa -->
              <!-- <b-card class="form-card" v-if="step == 1 || step == 3"> -->
              <template v-else>
                <!-- Thông tin mua hàng -->
                <b-card class="form-card" ref="order_info">
                  <div class="form-card_title my-2">Thông tin mua hàng</div>
                  <OrderInformationTableShowOnly v-if="processorStatus != 'PROCESSING' || isExportOrder" :lineItem="lineItemMerge"></OrderInformationTableShowOnly>
                  <template v-else>
                    <b-alert v-if="isUseImeiOrSerial" class="custom-alert" show variant="warning text-dark  ">
                      Vui lòng chọn IMEI/Serial hoặc sản phẩm theo lô HSD tương ứng số lượng khách hàng đã đặt.
                    </b-alert>
                    <!-- table -->
                    <OrderInformationTable v-if="refresh" :lineItem="lineItemMerge" @update-data="updateLineItem"></OrderInformationTable>
                  </template>

                  <!-- <PaymentInfor></PaymentInfor> -->
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Tổng tiền ({{ totalQuantity }} sản phẩm)</div>
                    <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(totalAmount)) }}</div>
                  </div>
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Thuế tổng đơn ({{ tax | formatPercent }}%)</div>
                    <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(taxAmount)) }}</div>
                  </div>
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Chiết khấu ({{ discont | formatPercent }}%)</div>
                    <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(discontAmount)) }}</div>
                  </div>
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Phí dịch vụ</div>
                    <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(feeAmount)) }}</div>
                  </div>
                  <!-- <template v-if="isDLO">
                    <div class="row py-1 justify-content-end text-right">
                      <div class="col-3 sub_title">Phí trả ĐTGH</div>
                      <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(DLOinfo.lineItemFinalizing.finalAmount))  }}</div>
                    </div>
                    <div class="row py-1 justify-content-end text-right">
                      <div class="col-3 sub_title">Phí ship báo khách</div>
                      <div class="col-2">{{ formatMoneyNotUnit(this.getFeeShip(this.orderData)) }}</div>
                    </div>
                    <div v-if="CODmoney && CODmoney > 0" class="row py-1 justify-content-end text-right">
                      <div class="col-3 sub_title">Tiền thu hộ COD</div>
                      <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(CODmoney)) }}</div>
                    </div>
                </template> -->
                  <div class="row justify-content-end">
                    <div class="col-5 border-bottom"></div>
                  </div>
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Khách phải trả</div>
                    <div class="col-2">
                      <b>{{ formatMoneyNotUnit(divisionThousand(customerMustPay)) }}</b>
                    </div>
                  </div>
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Khách trả</div>
                    <div class="col-2 text-primary">
                      <b>{{ formatMoneyNotUnit(divisionThousand(customerPayMoney)) }}</b>
                    </div>
                  </div>
                  <div class="row justify-content-end">
                    <div class="col-5 border-bottom"></div>
                  </div>
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Tiền thừa</div>
                    <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(refund)) }}</div>
                  </div>
                </b-card>

              </template>
              <!-- thanh toan -->
              <b-card class="form-card">
                <!-- <b-card class="form-card" v-if="step != 1"> -->
                <div class="form-card_title my-2">Thanh toán</div>
                <PaymentListTable :dataPays="dataPays"></PaymentListTable>
              </b-card>
            </template>

            <template v-if="isDLO && DLOinfo">
              <!-- <template> -->
              <!-- Thông tin giao hàng -->
              <b-card class="form-card" ref="deliveryInfo">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="form-card_title">
                    Thông tin giao hàng
                  </div>
                  <div class="d-flex" v-if="step != 0">
                    <!-- cpn delivery -->
                    <DiliveryPos
                      disabledFeeShip
                      @new-dlo-info="changeDLOinfoDone"
                      v-if="showDeliveryModal"
                      :modalDilivery="showDeliveryModal"
                      @clickModalDiliveryHide="showDeliveryModal = false"
                      :dloData="dloInfoTmp"
                    />

                    <template
                      v-if="
                        (orderData.deliveryData.params.deliveryStatus == 'FAILED' || orderData.deliveryData.params.deliveryStatus == 'CANCEL') && !isDLOdone && !isOrderOnlineHasDlo
                      "
                    >
                      <el-button type="primary" @click="handleCreateNewDlo">Tạo đơn giao hàng</el-button>
                    </template>
                    <template v-if="orderData.deliveryData.params.deliveryStatus == 'NEW' && !isDLOdone">
                      <!-- GH chưa đẩy qua hãng -->
                      <template v-if="!isPushedToPartner || !isDELIVERY_PARTNER">
                        <el-button v-if="!isOrderFormOnlineStore" type="danger" plain @click="showOrderDLOCancel = true">Bỏ giao hàng</el-button>
                        <el-button v-else type="danger" plain @click="showPopupCancelDloGHTT = true">Bỏ giao hàng</el-button>
                        <el-button plain @click="changeDLOinfo">Sửa thông tin</el-button>
                        <!-- <el-button plain @click="showDeliveryModal = true">Sửa thông tin</el-button> -->
                        <el-button v-if="isDELIVERY_PARTNER" @click="deliveryToPartner" type="primary">Đẩy đơn qua hãng</el-button>
                        <el-button v-else @click="deliveryToShipper" type="primary">Giao hàng cho shipper</el-button>
                      </template>
                      <!-- GH đã đẩy qua hãng -->
                      <template v-else>
                        <el-dropdown class="mr-2">
                          <el-button plain><i class="el-icon-arrow-down el-icon--left"></i>Hủy giao hàng</el-button>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="showPopupCancelAndRenewPartner = true">Huỷ giao & tạo đơn giao hàng mới</el-dropdown-item>
                            <el-dropdown-item class="text-danger" @click.native="showPopupCancelAllPartner = true">Huỷ giao & huỷ đơn hàng</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                        <el-button @click="deliveryToShipper" type="primary">Giao hàng cho shipper</el-button>
                      </template>
                    </template>
                    <template v-if="orderData.deliveryData.params.deliveryStatus == 'PROCESSING'">
                      <el-dropdown class="mr-2">
                        <el-button plain><i class="el-icon-arrow-down el-icon--left"></i>Hủy giao hàng</el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="checkOderFromPartner('showPopupCancelAndRenew')">Huỷ giao & tạo đơn giao hàng mới</el-dropdown-item>
                          <el-dropdown-item class="text-danger" @click.native="checkOderFromPartner('showPopupCancelAll')">Huỷ giao & huỷ đơn hàng</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button @click="showDeliveryDone = true" type="primary">Giao hàng thành công</el-button>
                    </template>
                  </div>
                </div>
                <template
                  v-if="
                    (orderData.deliveryData.params.deliveryStatus !== 'FAILED' && orderData.deliveryData.params.deliveryStatus !== 'CANCEL') || orderData.orderStatus == 'CANCELED'
                  "
                >
                  <div class="row my-4 align-items-center">
                    <div class="col-2 text-right sub_title">Mã đơn giao:</div>
                    <div class="col-4 d-flex">
                      {{ DLOinfo.orderNo }}
                      <router-link :to="`/orders-delivery/delivery-order-detail/${this.DLOinfo.id}`" class="w-100 text-primary d-flex ml-2">
                        <img class="mr-1" width="12px" height="12px" src="@assets/order-icon/arrow-detail.svg" alt="arrow-down" />
                        <b>Xem chi tiết đơn giao</b>
                      </router-link>
                    </div>
                    <div class="col-2 text-right sub_title">Trạng thái:</div>
                    <div class="col-4">
                      <StatusBox
                        :status="getDeliveryStatus(orderData.deliveryData.params.deliveryStatus, orderData).status"
                        :showText="getDeliveryStatus(orderData.deliveryData.params.deliveryStatus, orderData).text"
                      ></StatusBox>
                    </div>
                  </div>
                  <div class="row my-4">
                    <div class="col-2 text-right sub_title">Hình thức giao:</div>
                    <div v-if="!isDELIVERY_PARTNER" class="col-4">{{ getTypeShipper(DLOinfo.targetService) }}</div>
                    <div v-else class="col-4">{{ DELIVERY_INFO_DATA.partnerCode || "---" }}</div>
                    <template v-if="isDELIVERY_PARTNER">
                      <div class="col-2 text-right sub_title">Mã đơn của hãng:</div>
                      <div class="col-4">{{ DELIVERY_INFO_DATA.partnerOrderId || "---" }}</div>
                    </template>
                  </div>
                  <div class="row my-4">
                    <template v-if="!isDELIVERY_PARTNER">
                      <div class="col-2 text-right sub_title">Shipper:</div>
                      <div class="col-4">{{ DLOinfo.partyOther.displayName || "---" }}</div>
                    </template>
                    <template v-else>
                      <div class="col-2 text-right sub_title">Gói vận chuyển:</div>
                      <div class="col-4">{{ DELIVERY_INFO_DATA.partnerPackageName || "---" }}</div>
                    </template>
                    <div class="col-2 text-right sub_title">Phí trả ĐTGH:</div>
                    <div class="col-4">{{ formatMoney(divisionThousand(DLOinfo.lineItemFinalizing.finalAmount)) }}</div>
                  </div>
                  <div class="row my-4">
                    <div class="col-2 text-right sub_title">Phí ship báo khách:</div>
                    <div class="col-4">{{ formatMoney(this.getFeeShip(this.orderData)) }}</div>
                    <div class="col-2 text-right sub_title">Tiền thu hộ COD:</div>
                    <div class="col-4">{{ formatMoney(divisionThousand(CODmoney)) }}</div>
                  </div>
                  <div class="row my-4">
                    <div class="col-2 text-right sub_title">Ghi chú:</div>
                    <div class="col-10">{{ DLOinfo.note }}</div>
                  </div>
                </template>
                <div v-else class="w-100 my-5 text-center">
                  <img class="" src="@assets/order-icon/delivery-truck.svg" alt="arrow-down" />
                  <div class="text-secondary">Chưa có đơn giao hàng</div>
                </div>
                <!-- Lịch sử đơn giao hàng -->
                <div
                  class="mt-5"
                  v-if="this.orderData.deliveryData && this.orderData.deliveryData.params.deliveryHistory && this.orderData.deliveryData.params.deliveryHistory.length > 0"
                >
                  <div class="form-card_title my-2">Lịch sử đơn giao hàng</div>
                  <b-table @row-clicked="clickToDLO" :items="listDLO" :fields="fieldsDeliveryHistory" :key="updateUI" emptyText="Chưa ghi nhận giao hàng." show-empty>
                    <template #cell(processorStatus)="data">
                      <StatusBox
                        :status="getDeliveryStatus(data.item.processorStatus, orderData).status"
                        :showText="getDeliveryStatus(data.item.processorStatus, orderData).text"
                      ></StatusBox>
                    </template>
                    <template #cell(FeeDelivery)="data">
                      <div>{{ formatMoney(divisionThousand(data.item.lineItemFinalizing.finalAmount)) }}</div>
                    </template>
                    <template #cell(returnFee)="data">
                      <div>{{ formatMoney(divisionThousand(data.item.returnFee)) }}</div>
                    </template>
                    <template #cell(checkoutAt)="data">
                      <div>{{ data.item.checkoutAt ? timeFormatStatus(data.item.checkoutAt) : "Chưa xuất kho" }}</div>
                    </template>
                  </b-table>
                </div>
              </b-card>

              <!-- thanh toán -->
              <b-card class="form-card" ref="paymentInfo">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="form-card_title">
                    Thanh toán
                  </div>
                  <div v-if="!isDLOdone && isNotCODpayment">
                    <el-button v-if="!isOrderFormOnlineStore" @click="handleShowConfirmPayment" type="primary">Xác nhận đã nhận COD</el-button>
                    <el-button v-else @click="handleShowConfirmPayment" type="primary">Xác nhận đã nhận COD</el-button>
                  </div>
                </div>
                <div class="row my-4">
                  <div class="col-2 text-right sub_title">Tổng phải trả:</div>
                  <div class="col-10">{{ formatMoney(divisionThousand(customerMustPay)) }}</div>
                </div>
                <div class="row my-4">
                  <div class="col-2 text-right sub_title">Đã trả trước:</div>
                  <div class="col-4">{{ formatMoney(divisionThousand(totalPayment)) }}</div>
                  <div class="col-2 text-right sub_title">Tiền thu hộ COD:</div>
                  <div class="col-4">{{ formatMoney(divisionThousand(CODmoney)) }}</div>
                </div>

                <PaymentListTable :dataPays="dataPays"></PaymentListTable>
              </b-card>

              <!-- thông tin sản phẩm -->
              <b-card class="form-card" ref="order_info">
                <div class="form-card_title my-2">Thông tin mua hàng</div>
                <OrderInformationTableShowOnly v-if="processorStatus != 'PROCESSING' || isExportOrder" :lineItem="lineItemMerge"></OrderInformationTableShowOnly>
                <template v-else>
                  <b-alert v-if="isUseImeiOrSerial" class="custom-alert" show variant="warning text-dark">
                    Vui lòng chọn IMEI/Serial hoặc sản phẩm theo lô HSD tương ứng số lượng khách hàng đã đặt.
                  </b-alert>
                  <!-- table -->
                  <OrderInformationTable v-if="refresh" :lineItem="lineItemMerge" @update-data="updateLineItem"></OrderInformationTable>
                </template>

                <div class="row py-1 justify-content-end text-right">
                  <div class="col-3 sub_title">Tổng tiền ({{ totalQuantity }} sản phẩm)</div>
                  <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(totalAmount)) }}</div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-3 sub_title">Thuế tổng đơn ({{ tax | formatPercent }}%)</div>
                  <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(taxAmount)) }}</div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-3 sub_title">Chiết khấu ({{ discont | formatPercent }}%)</div>
                  <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(discontAmount)) }}</div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-3 sub_title">Phí dịch vụ</div>
                  <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(feeAmount)) }}</div>
                </div>
                <template v-if="isDLO">
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Phí trả ĐTGH</div>
                    <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(DLOinfo.lineItemFinalizing.finalAmount))  }}</div>
                  </div>
                  <div class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Phí ship báo khách</div>
                    <div class="col-2">{{ formatMoneyNotUnit(this.getFeeShip(this.orderData)) }}</div>
                  </div>
                  <div v-if="CODmoney && CODmoney > 0" class="row py-1 justify-content-end text-right">
                    <div class="col-3 sub_title">Tiền thu hộ COD</div>
                    <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(CODmoney)) }}</div>
                  </div>
                </template>
                <div class="row justify-content-end">
                  <div class="col-5 border-bottom"></div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-3 sub_title">Khách phải trả</div>
                  <div class="col-2">
                    <b>{{ formatMoneyNotUnit(divisionThousand(customerMustPay)) }}</b>
                  </div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-3 sub_title">Khách trả</div>
                  <div class="col-2 text-primary">
                    <b>{{ formatMoneyNotUnit(divisionThousand(customerPayMoney)) }}</b>
                  </div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-5 border-bottom"></div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-3 sub_title">Tiền thừa</div>
                  <div class="col-2">{{ formatMoneyNotUnit(divisionThousand(refund)) }}</div>
                </div>
              </b-card>
            </template>

            <!-- Lịch sử trả hàng -->
            <b-card class="form-card" v-if="status === 'SUCCESS'">
              <div class="w-100 d-flex justify-content-between">
                <div class="form-card_title my-2">Lịch sử trả hàng</div>
                <el-button plain type="primary" :disabled="!isReturnAble" @click="addNewReturn">Thêm mới đơn trả</el-button>
              </div>
              <div class="row justify-content-center">
                <div class="col-8">
                  <b-alert class="custom-alert mt-3" id="refIdReturnOutDate" v-show="isReturnOutDate" show variant="warning text-dark  ">
                    Cửa hàng đã cấu hình thời gian đổi trả hàng trong vòng
                    <b>{{ merchantReturn.returnTimeLimit + " " + getReturnTimeUnit[merchantReturn.returnTimeUnit] }}</b> tính từ ngày mua hàng thành công.<br />
                    Để cài đặt lại, vui lòng đi tới
                    <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
                  </b-alert>
                </div>
              </div>
              <ReturnHistoryTable></ReturnHistoryTable>
            </b-card>
          </div>
        </div>
      </div>
      <!-- header -->
    </div>
    <NotPermission v-else></NotPermission>

    <!-- loading -->
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>

    <!-- popup -->
    <el-dialog custom-class="popup-pos-detail" title="Huỷ đơn hàng" width="600px" :visible.sync="showOrderCancel" :show-close="false">
      <div class="body">
        <div class="image" style="height: 120px">
          <!-- <img src="@assets/order-icon/Box-decline.png" /> -->
          <img src="@assets/order-icon/Discard-order.png" />
        </div>
        <div class="mt-3">Bạn có chắc chắn muốn hủy đơn hàng này không?</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-custom" @click="showOrderCancel = false">Quay lại</el-button>
        <el-button @click="deleteItem(itemId)" plain type="danger">Hủy đơn</el-button>
      </div>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" title="Xác nhận huỷ đơn hàng" width="600px" :visible.sync="ReturnAllItemsModal" :show-close="false">
      <div class="body">
        <div class="image" style="height: 120px">
          <!-- <img src="@assets/order-icon/Box-decline.png" /> -->
          <img src="@assets/order-icon/Discard-order.png" />
        </div>
        <div style="display: flex;flex-direction: column;align-items: center;">
          <div class="mt-3">
            Bạn có chắc chắn muốn hủy đơn hàng <b>{{ itemId }}</b> ?
          </div>
          <div class="mt-3" style="max-width:412px; text-align:center">Hệ thống sẽ tiến hành thực hiện đơn trả hàng và nhập lại kho những sản phẩm trong đơn hàng.</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-custom" @click="ReturnAllItemsModal = false">Quay lại</el-button>
        <el-button @click="confirmReturnItems()" plain type="danger">Xác nhận hủy</el-button>
      </div>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" title="Xuất kho không thành công" width="600px" :visible.sync="showExport" :show-close="false">
      <div class="body">
        <div class="image" style="height: 120px">
          <img src="@assets/order-icon/Box-decline.png" />
        </div>
        <div class="mt-3 text-center text-break">
          Vui lòng chọn IMEI/Serial hoặc sản phẩm theo lô HSD tương ứng với số lượng khách hàng đã đặt.
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showExport = false" plain type="primary">Đóng</el-button>
      </div>
    </el-dialog>

    <!-- DLO xác nhận thanh toán -->
    <el-dialog custom-class="popup-pos-detail popup-pos-detail_custom" title="Xác nhận thanh toán" width="600px" :visible.sync="showConfirmPaymentDLO" :show-close="false">
      <div class="body-confirm">
        <b-alert class="custom-alert w-100" style="word-break: normal;" variant="warning text-dark" show>
          Bạn cần xác nhận thanh toán của khách hàng cho đơn giao hàng đối với các hình thức thanh toán bằng COD
        </b-alert>

        <b-table :items="dataPays.filter((e) => e.payMethod == 'COD')" :fields="payFieldsPopupCOD" :key="updateUI" emptyText="Đơn chưa có thanh toán nào" show-empty>
          <!-- 1 -->
          <template #cell(requestAt)="data">
            <div>{{ timeFormatDate(data.item.requestAt) }}</div>
          </template>
          <template #cell(customerName)="data">
            <div>{{ orderData.partyB.displayName }}</div>
          </template>
          <template #cell(payMethod)="data">
            <div>{{ allPayment[data.item.payMethod + "_" + data.item.payGateway].name || data.item.payMethod }}</div>
          </template>
          <template #cell(amount)="data">
            <div>{{ formatMoney(divisionThousand(data.item.amount)) }}</div>
          </template>
        </b-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showConfirmPaymentDLO = false" plain type="primary">Đóng</el-button>
        <el-button class="mr-2" @click="confirmPaymentDLO" type="primary">Xác nhận</el-button>
      </div>
    </el-dialog>

    <!-- GHTT xac nhan thanh toan -->
    <el-dialog custom-class="popup-pos-detail popup-pos-detail_custom" width="600px" title="Xác nhận thanh toán" :visible.sync="showConfirmPayment" :show-close="false">
      <div class="body-confirm">
        <b-alert class="custom-alert w-100" variant="warning text-dark" show>
          Bạn cần xác nhận thanh toán của khách hàng cho đơn hàng từ NextShop Web đối với các hình thức thanh toán bằng COD, chuyển khoản.
        </b-alert>

        <b-table :items="dataPays" :fields="payFieldsPopup" :key="updateUI" emptyText="Đơn chưa có thanh toán nào" show-empty>
          <!-- 1 -->
          <template #cell(requestAt)="data">
            <div>{{ timeFormatDate(data.item.requestAt) }}</div>
          </template>
          <template #cell(customerName)="data">
            <div>{{ orderData.partyB.displayName }}</div>
          </template>
          <template #cell(payMethod)="data">
            <div>{{ allPayment[data.item.payMethod + "_" + data.item.payGateway].name || data.item.payMethod }}</div>
          </template>
          <template #cell(amount)="data">
            <div>{{ formatMoney(divisionThousand(data.item.amount)) }}</div>
          </template>
        </b-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showConfirmPayment = false" plain type="primary">Đóng</el-button>
        <el-button @click="confirmPayment" type="primary">Xác nhận</el-button>
      </div>
    </el-dialog>

    <el-dialog
      @opened="$refs.childEditForm.createData()"
      custom-class="popup-pos-detail"
      title="Thay đổi thông tin khách hàng"
      width="600px"
      :visible.sync="showChangeCustomer"
      :show-close="false"
    >
      <div class="body">
        <EditCustomerForm
          @closeModal="
            showChangeCustomer = false;
            fetchData();
          "
          ref="childEditForm"
          :id="itemId"
          :partyB="orderData.partyB"
        ></EditCustomerForm>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-custom" @click="showChangeCustomer = false">Thoát</el-button>
        <el-button type="primary" @click="$refs.childEditForm.submit()">Lưu</el-button>
      </div>
    </el-dialog>

    <!-- popup DLO -->
    <CancelAndCloneOrder v-if="orderData && orderData.lineItemFinalizing" :isCustomerPaid="isPayedAPart" :feeShip="getFeeShip(orderData)" :datas="datas" :show="showOrderDLOCancel" :DLOid="DLOid" @close="showOrderDLOCancel = false"></CancelAndCloneOrder>

    <el-dialog custom-class="popup-pos-detail" title="Xác nhận giao hàng thành công" width="600px" :visible.sync="showDeliveryDone">
      <div class="body text-center">
        <div class="image" style="height: 120px">
          <img src="@assets/order-icon/Delivery_hand_done.png" />
        </div>
        <div class="mt-3">Xác nhận đã giao hàng cho khách.</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deliveryDone" type="primary">Đồng ý</el-button>
      </div>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" title="Xác nhận giao hàng thành công" width="600px" :visible.sync="showDeliveryAllDone">
      <div class="body text-center">
        <div class="image" style="height: 120px">
          <img src="@assets/order-icon/Delivery_hand_done.png" />
        </div>
        <div class="mt-3">Xác nhận <b>đã ship</b> và <b>giao hàng cho khách</b>.</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deliveryAllDone" type="primary">Đồng ý</el-button>
      </div>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" title="Xác nhận giao hàng thành công" width="600px" :visible.sync="showExportOrder">
      <div class="body text-center">
        <div class="image" style="height: 120px">
          <img src="@assets/order-icon/Delivery_hand_done.png" />
        </div>
        <div class="mt-3">Xác nhận <b>đã xuất kho</b> và <b>giao hàng cho khách</b>.</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportOrder" type="primary">Đồng ý</el-button>
      </div>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Xác nhận huỷ giao & huỷ đơn hàng" :visible.sync="showPopupCancelAll">
      <div class="text-center">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon" />
        <p class="mb-3">Đơn giao và đơn hàng sẽ <b>bị huỷ</b></p>
      </div>
      <div class="cancel-info">
        <b-alert class="custom-alert w-100" variant="warning text-dark" show>
          <template v-if="!isPayedAPart">Phí trả ĐTGH và phí huỷ đơn sẽ tự động <b>trừ vào doanh thu</b>.</template>
          <template v-else>
            Đơn hàng đã được thanh toán, hãy chắc chắn hoàn tiền cho khách trước khi xác nhận huỷ đơn.<br />
            Phí trả ĐTGH và phí huỷ đơn sẽ tự động <b>trừ vào doanh thu</b>.
          </template>
        </b-alert>
        <div class="row align-items-center">
          <div class="col-7">Nhập chi phí phát sinh khi huỷ đơn (nếu có):</div>
          <div class="col-5">
            <InputMoneyVmodel class="form-control text-right" v-model="feeDLO"></InputMoneyVmodel>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCancelAll" type="primary">Xác nhận hủy</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Xác nhận huỷ giao & huỷ đơn hàng" :visible.sync="showPopupCancelAllPartner">
      <div class="text-center">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon" />
        <p class="mb-3">Đơn giao và đơn hàng sẽ <b>bị huỷ</b></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCancelAllPartner" type="primary">Xác nhận hủy</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Xác nhận huỷ giao & tạo đơn giao hàng mới" :visible.sync="showPopupCancelAndRenew">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon" />
        <p class="mb-3" style="width:70%">
          Đơn giao hàng hiện tại sẽ <b>bị huỷ</b>, vui lòng
          <b
            >tạo 1 đơn <br />
            giao hàng mới</b
          >
          để tiếp tục bán.
        </p>
      </div>
      <div class="cancel-info">
        <b-alert class="custom-alert w-100" variant="warning text-dark" show
          >Thao tác huỷ giao có thể phát sinh chi phí. Phí trả ĐTGH và phí huỷ sẽ tự động <b>trừ vào doanh thu</b>.</b-alert
        >
        <div class="row align-items-center">
          <div class="col-7">Nhập chi phí phát sinh khi huỷ đơn (nếu có):</div>
          <div class="col-5">
            <InputMoneyVmodel class="form-control text-right" v-model="feeDLO"></InputMoneyVmodel>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCancelAndRenew" type="primary">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Xác nhận huỷ giao & tạo đơn giao hàng mới" :visible.sync="showPopupCancelAndRenewPartner">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon" />
        <p class="mb-3" style="width:70%">
          Đơn giao hàng hiện tại sẽ <b>bị huỷ</b>, vui lòng
          <b
            >tạo 1 đơn <br />
            giao hàng mới</b
          >
          để tiếp tục bán.
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCancelAndRenewPartner" type="primary">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Liên hệ để hủy đơn" :visible.sync="showIsNotCancel">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/order-icon/Delivery_hand_nope.png" alt="icon" />
        <div>Hàng đã được giao cho đối tác vận chuyển, vui lòng liên hệ<br />tổng đài Hey U <a href="tel:+841900633689" class="text-primary">1900633689</a> để được hỗ trợ.</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showIsNotCancel = false" type="primary">Đóng</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Bỏ giao hàng" :visible.sync="showPopupCancelDloGHTT">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/order-icon/Delivery_hand_nope.png" alt="icon" />
        <div>Bạn có chắc chắn muốn bỏ giao hàng?</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmCancelDloGHTT" type="primary">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Xác nhận huỷ đơn hàng" :visible.sync="showOrderDLOCancelAndDoNothing">
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon" />
        <p class="mb-3" style="width:70%">Xác nhận đơn đơn hàng sẽ <b>bị huỷ</b>.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="() => handleOrderDLOCancelAndDoNothing(DLOid)" type="primary">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog custom-class="popup-pos-detail" width="600px" title="Khoản hoàn tiền đã được tạo" :visible.sync="showReturnMoneyForCustomer">
      <div class="text-center">
        <img src="@/assets/order-icon/money-card.svg" alt="icon" />
        <div class="text-center mt-2">
          Một khoản nợ đã được tạo để hoàn tiền cho khách hàng.<br />
          Vui lòng chuyển sang tính năng Công nợ để xác nhận hoàn tiền cho khách.
        </div>
        <b-table :items="returnMoneyCustomer" :fields="returnMoneyCustomerFields" :key="updateUI">
          <!-- 1 -->
        </b-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showReturnMoneyForCustomer = false" type="primary">Đồng ý</el-button>
      </span>
    </el-dialog>

    <!-- in hoa don -->
    <Prints v-if="!loading" :orderData="orderData" :clickOpen="clickOpenTypeShowModal" @clickOpen="clickOpenTypeShowModal = $event" />
  </div>
</template>

<script>
import { LocationService } from "@/services/nextshop/location.service";
import { OrdersService } from "@/services/nextshop/orders.service";
import { getStorageItem, removeStorageItem, setStorageItem } from "@/utils/auth";
import { SettingService } from "@/services/nextshop/setting.service";

import Header from "./components/header.vue";
import ReturnHistoryTable from "./components/returnHistoryTable.vue";
import OrderInformationTable from "./components/orderInformationTable.vue";
import OrderInformationTableShowOnly from "./components/orderInformationTableShowOnly.vue";
import { mapMutations } from "vuex";
// import Swal from "sweetalert2";
import Prints from "./components/prints";
import moment from "moment";
import EditCustomerForm from "./components/editCustomerForm.vue";
import _ from "lodash";
import { allPayment, getDeliveryStatus } from "@/utils/mapping";
import StatusBox from "@/components/status-box.vue";
import DiliveryPos from "../V2/pos/components/dilivery.vue";
import InputMoneyVmodel from "../orders-return/components/inputMoneyVmodel.vue";
import PaymentListTable from "./components/paymentListTable.vue";
import CancelAndCloneOrder from "./components/CancelAndCloneOrder.vue";
import { dloInfoPos } from "@/utils/pos";
import { getAllAddressName } from "@/utils/address";
import getPosDloInfo from "@/utils/delivery";
import convertDataFromDLOform from "@/utils/delivery";
import { clonePosData } from "./utils.js";
import deliveryMixin from "./deliveryMixin.js";

export default {
  mixins: [getPosDloInfo, convertDataFromDLOform, deliveryMixin],
  components: {
    Header,
    ReturnHistoryTable,
    OrderInformationTable,
    OrderInformationTableShowOnly,
    Prints,
    EditCustomerForm,
    StatusBox,
    DiliveryPos,
    InputMoneyVmodel,
    PaymentListTable,
    CancelAndCloneOrder,
  },
  data() {
    return {
      feeDLO: 0,
      allPayment: allPayment,
      dataPermission: getStorageItem("dataPermission"),
      loading: false,
      refresh: false,
      itemId: this.$route.params.id,

      step: 0,
      status: "",
      processorStatus: "",
      stepsArr: [
        // step 0
        {
          name: "Đặt hàng",
          description: "",
        },
        {
          name: "Đang giao dịch",
          description: "",
        },
        {
          name: "Hoàn thành",
          description: "",
        },
      ],

      updateUI: 1,
      orderData: {},
      datas: {},
      lineItem: [],
      lineItemMerge: [],
      fields: [
        {
          key: "index",
          label: "#",
          thStyle: { width: "2%" },
        },
        {
          key: "sku",
          label: "Mã SKU",
          thStyle: { width: "4%" },
        },
        {
          key: "sku1",
          label: "Tên phiên bản sản phẩm",
          thStyle: { width: "4%", minWidth: "120px" },
        },
        {
          key: "quantity",
          label: "Số lượng",
          thStyle: { width: "4%" },
        },
        {
          key: "price",
          label: "Đơn giá",
          thStyle: { width: "4%" },
        },
        {
          key: "price1",
          label: "Thành tiền",
          thStyle: { width: "4%" },
        },
      ],

      dataPays: [],
      payFieldsPopup: [
        {
          key: "requestAt",
          label: "Thời gian",
          thStyle: { width: "4%" },
        },
        {
          key: "customerName",
          label: "Khách hàng",
          thStyle: { width: "4%" },
        },
        {
          key: "payMethod",
          label: "Phương thức",
          thStyle: { width: "4%" },
        },
        {
          key: "amount",
          label: "Số tiền",
          thStyle: { width: "4%" },
        },
      ],
      payFieldsPopupCOD: [
        {
          key: "payMethod",
          label: "Phương thức",
          thStyle: { width: "4%" },
        },
        {
          key: "amount",
          label: "Số tiền",
          thStyle: { width: "4%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      listDLO: [],
      fieldsDeliveryHistory: [
        {
          key: "orderNo",
          label: "Mã đơn chuyển",
          thStyle: { width: "4%" },
          tdClass: "text-primary text-bold",
        },
        {
          key: "checkoutAt",
          label: "Ngày xuất kho",
          thStyle: { width: "4%" },
        },
        {
          key: "partyOther.displayName",
          label: "Shipper",
          thStyle: { width: "4%" },
        },
        {
          key: "processorStatus",
          label: "Trạng thái",
          thStyle: { width: "4%" },
        },
        {
          key: "FeeDelivery",
          label: "Phí trả ĐTGH",
          thStyle: { width: "4%" },
        },
        {
          key: "returnFee",
          label: "Phí huỷ",
          thStyle: { width: "4%" },
        },
      ],

      informationTabs: "first",

      isReturnAble: true,
      isReturnOutDate: false,
      isOrderFormOnlineStore: false,
      isUseImeiOrSerial: false,
      isDLO: false,
      isDELIVERY_PARTNER: false,
      isPushedToPartner: false,
      DLOid: null,
      DLOinfo: null,
      isDLOdone: true,
      // dloInfo: dloInfoPos,
      initDataPickUpAddress: null,

      // pôpup
      showOrderCancel: false,
      showConfirmPayment: false,
      showConfirmPaymentDLO: false,
      showExport: false,
      showChangeCustomer: false,
      clickOpenTypeShowModal: false,
      ReturnAllItemsModal: false,
      showOrderDLOCancel: false,
      showOrderDLOCancelAndDoNothing: false,
      showDeliveryModal: false,
      showDeliveryDone: false,
      showDeliveryAllDone: false,
      showPopupCancelAll: false,
      showPopupCancelAllPartner: false,
      showPopupCancelAndRenew: false,
      showPopupCancelAndRenewPartner: false,
      showReturnMoneyForCustomer: false,
      showPopupCancelDloGHTT: false,
      showExportOrder: false,
      showIsNotCancel: false,

      returnMoneyCustomerFields: [
        {
          key: "ma1",
          label: "Mã khoản trả",
          thStyle: { width: "4%" },
          tdClass: "text-primary text-bold",
        },
        {
          key: "voi1",
          label: "Giao dịch với",
          thStyle: { width: "4%" },
        },
        {
          key: "money1",
          label: "Tổng phải trả",
          thStyle: { width: "4%" },
        },
        {
          key: "status1",
          label: "Trạng thái",
          thStyle: { width: "4%" },
        },
      ],
      returnMoneyCustomer: [],

      branch: "",
      dataLocation: "",

      // caculator
      tax: 0,
      taxAmount: 0,
      discont: 0,
      discontAmount: 0,
      totalAmount: 0,
      totalQuantity: 0,
      feeAmount: 0,
      customerMustPay: 0,
      customerPayMoney: 0,
      refund: 0,

      // customerForm

      idReturnOutDate: "",
      merchantReturn: {},
      getReturnTimeUnit: {
        DAYS: "Ngày",
        WEEKS: "Tuần",
        MONTHS: "Tháng",
        YEARS: "Năm",
      },
      targetMethodName: {
        NEXT_SHOP_POS_WEB_ENABLE_DRAFT: "NextShop Web",
        SALE_ONLINE_STORE: "NextShop Web",
        NEXT_SHOP_POS_APP: "NextShop App",
      },
      // payMethodList: {
      //   CASH: "Tiền mặt",
      //   SWIPE: "Quẹt thẻ",
      //   BANK_TRANSFER: "Chuyển khoản",
      //   COD: "Thanh toán khi nhận hàng COD",
      //   ONLINE: "ONLINE",
      //   REFUND: "Hoàn tiền"
      // },
      totalPayment: 0,
      dloInfoTmp: null
    };
  },
  async created() {
    // return
    this.getMainApiMerchantReturn();
    await this.fetchData();
    if (this.$route.query.isReNew && this.orderData.deliveryData.params.deliveryStatus == "FAILED" && !this.isDLOdone) this.handleCreateNewDlo();
    // console.log("fetchData");
  },
  methods: {
    ...mapMutations("sell", ["SET_INFO_SELL", "SET_RM_ID"]),

    async getMainApiMerchantReturn() {
      try {
        const response = await SettingService.mainApiMerchant();
        if (response.success) {
          const temp = {};
          temp.enableLimitReturnTime = response.data.enableLimitReturnTime;
          temp.returnTimeLimit = response.data.returnTimeLimit;
          temp.returnTimeUnit = response.data.returnTimeUnit;
          this.merchantReturn = temp;
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Có lỗi", error, "error");
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await OrdersService.getOrderById(this.$route.params.id);
        if (response.success) {
          // console.log(34343344);
          // response.data = this.outputOrdersData(response.data)
          // return
          const copyDeepRes = _.cloneDeep(response.data);
          // this.datas = this.outputOrdersData(copyDeepRes);
          this.datas = copyDeepRes;
          // return
          this.orderData = response.data;
          this.lineItem = response.data.lineItem;
          this.loading = false;
          // merge lo HSD
          if (this.lineItem && this.lineItem.length > 0) {
            const lineItem = _.cloneDeep(this.lineItem);
            this.lineItemMerge = this.mergeLineItemLoHsd(lineItem);
            // console.log(123, this.orderData);

            this.lineItemMerge.forEach((e) => {
              // series
              // console.log(12321, e)
              if ((e.lineItemOtherInfo.seriesNo && e.lineItemOtherInfo.seriesNo.length > 0) || e.lineItemOtherInfo.managementType == "SERIAL") {
                e.useImeiAndSerial = true;
                e._showDetails = true;
                e.seriesNoTmp = [];
                e.getSeri = [];
                this.isUseImeiOrSerial = true;
              }

              // lo HSD
              if ((e.lineItemOtherInfo.productBatch && e.lineItemOtherInfo.productBatch != null) || e.lineItemOtherInfo.managementType == "BATCH") {
                this.isUseImeiOrSerial = true;
                e.useProductBatch = true;
                e._showDetails = true;
                if (e.batchTmp == undefined) {
                  e.batchTmp = [];
                }
              }
            });
            // check delivery
            this.orderData.deliveryData = {};
            this.orderData.deliveryHistoryLast = {};
            if (this.orderData.furtherInstructions) {
              // const deliveryData = this.orderData.furtherInstructions.find(item => item.key == "SO_ORDER_OPERATION" && item.params && item.params.deliveryStatus && item.params.deliveryStatus != null)
              const deliveryData = this.orderData.furtherInstructions.find((item) => item.key == "SO_ORDER_OPERATION");
              if (deliveryData) {
                //check DLO
                if (deliveryData.params && deliveryData.params.deliveryStatus && deliveryData.params.deliveryStatus != null) {
                  this.isDLO = true;
                  deliveryData.params.deliveryHistory = JSON.parse(deliveryData.params.deliveryHistory ? deliveryData.params.deliveryHistory : "[]");
                  if (deliveryData.params.deliveryHistory.length) {
                    this.orderData.deliveryHistoryLast = deliveryData.params.deliveryHistory.at(-1);
                    this.DLOid = this.orderData.deliveryHistoryLast.deliveryOrderId;
                  }
                  this.orderData.deliveryData = deliveryData;
                  this.getListDLO();
                  //call api chi tiet don DLO
                  await this.getDLOinfor(this.DLOid);
                } else {
                  this.orderData.deliveryData = deliveryData;
                }
              }
            }

            this.checkStep();
            this.branch = this.orderData.locationToCreate;
            this.getDataLocation(this.branch);
            this.calculateData(this.orderData);
            this.getInforPayMethod();

            // check is returnable
            if (this.orderData.orderStatus == "SUCCESS") {
              this.isReturnAble = false;
              for (let i = 0; i < lineItem.length; i++) {
                const item = lineItem[i];
                const returnable = item.lineItemOtherInfo.returnable ? +item.lineItemOtherInfo.returnable : null;
                if (returnable === null || returnable > 0) {
                  this.isReturnAble = true;
                  break;
                }
              }
            }
          }
        }
        this.refresh = false;
        await this.sleep(50);
        this.refresh = true;
      } catch (error) {
        console.log(error);
        this.showNotify("Có lỗi", error, "error");
      } finally {
        this.loading = false;
      }
    },

    // tabClick(tab, event) {
    //   console.log(tab, event);
    // },

    checkStep() {
      this.isDLOdone = true;
      // const status = this.orderData.orderStatus
      const status = this.orderData.orderStatus;
      const processorStatus = this.orderData.processorStatus;
      this.status = status;
      this.processorStatus = processorStatus;

      // tét
      // this.step = 1
      // this.orderData.targetMethod = "SALE_ONLINE_STORE"
      // this.status = "PROCESS"

      // check đơn nháp từ gian hàng trực tuyến
      this.isOrderFormOnlineStore = false;
      if (this.orderData.targetMethod === "SALE_ONLINE_STORE" && status == "DRAFT") {
        this.isDLOdone = false;
        this.step = 1;
        this.isOrderFormOnlineStore = true;
        this.stepsArr = [
          {
            name: "Đặt hàng",
            description: this.timeFormatStatus(this.orderData.statusHistory[1].modifiedAt),
          },
          {
            name: "Đang giao dịch",
            description: "",
          },
          {
            name: "Hoàn thành",
            description: "",
          },
        ];
        return;
      }

      // CHECK ĐƠN CÓ DLO
      if (this.isDLO && processorStatus == "NEW") {
        this.isDLOdone = false;
        this.step = 0;
        this.stepsArr = [
          {
            name: "Đặt hàng",
            description: "",
          },
          {
            name: "Đang giao dịch",
            description: "",
          },
          {
            name: "Hoàn thành",
            description: "",
          },
        ];
        return;
      }

      if (this.isDLO && processorStatus == "PROCESSING") {
        this.isDLOdone = false;
        this.step = 1;
        this.stepsArr = [
          {
            name: "Đặt hàng",
            description: this.timeFormatStatus(this.orderData.statusHistory[1].modifiedAt),
          },
          {
            name: "Đang giao dịch",
            description: "",
          },
          {
            name: "Hoàn thành",
            description: "",
          },
        ];
        return;
      }

      // check đơn thường
      if (status === "DRAFT" && this.step == 0) {
        this.stepsArr = [
          {
            name: "Đặt hàng",
            description: this.timeFormatStatus(this.orderData.createdAt),
          },
          {
            name: "Đang giao dịch",
            description: "",
          },
          {
            name: "Hoàn thành",
            description: "",
          },
        ];
        return;
      }

      if (status === "SUCCESS" && processorStatus != "CANCEL") {
        this.step = 3;
        this.stepsArr = [
          {
            name: "Đặt hàng",
            description: this.timeFormatStatus(this.orderData.statusHistory[1].modifiedAt),
          },
          {
            name: "Đang giao dịch",
            description: this.timeFormatStatus(this.orderData.statusHistory[2].modifiedAt),
          },
          {
            name: "Hoàn thành",
            description: this.timeFormatStatus(this.orderData.statusHistory[3].modifiedAt),
          },
        ];
        return;
      }

      if (status === "CANCELED" || processorStatus == "CANCEL") {
        this.step = 2;
        this.stepsArr = [
          {
            name: "Đặt hàng",
            description: this.timeFormatStatus(this.orderData.createdAt),
          },
          {
            name: "Đã hủy",
            class: "cancel",
            description: this.timeFormatStatus(this.orderData.updatedAt),
          },
        ];
        return;
      }

      // test
      // this.step = 1
    },

    calculateData({ lineItemFinalizing, outcomes, lineItemAgg }) {
      // console.log(33, lineItemFinalizing);
      const { finalAmount, netSubTotal, addedFee } = lineItemFinalizing;
      addedFee.map((e) => {
        // TAX
        if (e.key == "TAX_ALL") {
          this.taxAmount = +e.amount;
        }

        // discount
        if (e.key == "DISCOUNT_ALL") {
          this.discontAmount = Math.abs(+e.amount);
          this.discont = this.discontAmount / (netSubTotal || 1);
          // console.log(888, this.discont);
        }

        // fee
        if (e.key == "OTHER_FEE") {
          this.feeAmount = +e.amount;
        }
      });
      this.tax = this.taxAmount / ((netSubTotal - this.discontAmount) || 1);

      this.totalAmount = +netSubTotal;
      this.customerMustPay = +finalAmount;

      // customerPayMoney
      let totalCustomerPayMoney = 0;
      outcomes.map((e) => {
        let price = 0;
        if (e.params.status == "SUCCESS") {
          price = +e.params.amount;
        }
        totalCustomerPayMoney += price;
      });
      this.customerPayMoney = totalCustomerPayMoney;

      this.refund = this.customerPayMoney - this.customerMustPay;

      lineItemAgg.quantityAgg.forEach((e) => {
        this.totalQuantity += e.quantity;
      });
    },

    getInforPayMethod() {
      // console.log(this.orderData);
      const mapPayment = {};
      this.dataPays = [];
      this.totalPayment = 0;
      this.orderData.outcomes.map((e) => {
        if (e.params && e.params.amount && e.cat == "NSH_PAYMENT") {
          if (e.key != "COD_NEXT_SHOP" && e.params.status == "SUCCESS") {
            this.totalPayment += +e.params.amount;
          }
          if (!mapPayment[e.key]) {
            this.dataPays.push(e.params);
            mapPayment[e.key] = e;
          } else {
            mapPayment[e.key].params.amount = +mapPayment[e.key].params.amount + +e.params.amount;
          }
        }
      });
      // console.log(33, this.dataPays)
    },

    checkIsReturn(timeUpdate) {
      if (this.merchantReturn.enableLimitReturnTime) {
        const timeOrder = moment(timeUpdate);
        const timeOutDate = moment().subtract(this.merchantReturn.returnTimeLimit, this.merchantReturn.returnTimeUnit);
        const timestand = timeOrder - timeOutDate;
        if (timestand > 0) return true;
        return false;
      } else {
        return true;
      }
    },
    showNotifyNotReturn() {
      clearTimeout(this.idReturnOutDate);
      this.isReturnOutDate = true;
      setTimeout(() => {
        let messageElemnt = this.$el.querySelector("#refIdReturnOutDate");
        messageElemnt.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 50);

      this.idReturnOutDate = setTimeout(() => {
        this.isReturnOutDate = false;
      }, 10000);
    },

    async addNewReturn() {
      if (!this.checkIsReturn(this.orderData.updatedAt)) {
        this.showNotifyNotReturn();
        return;
      }

      this.$router.push(`/orders-return/create/${this.itemId}`);
    },

    //Get Data Location
    async getDataLocation(locationId) {
      try {
        if (locationId !== "") {
          const response = await LocationService.getDetailLocation({ locationId: locationId });
          if (response.success) {
            this.dataLocation = response.data;
          }
        }
      } catch (error) {
        console.log(error);
        // this.showNotify("Có lỗi",error,"error")
      }
    },

    // handle
    cancelOrder() {
      // this.showSwalSuccess("Xác nhận thanh toán")
      // return
      this.showOrderCancel = true;
    },
    //Add Item Drafts
    async addItem() {
      const data = {
        activeNegativeInv: false,
        enableInventory: false,
        orders: [],
        paymentChoose: [],
      };
      const datas = this.outputOrdersData(this.datas);
      const cart = clonePosData(this.$route.params.id, datas);
      // console.log(cart)
      // return
      // don nhap có giao hang
      if (this.isDLO) {
        const posDloInfo = await this.getPosDloInfo(this.DLOinfo, this.getFeeShip(this.orderData));
        cart.dloInfo = {};
        cart.dloInfo = posDloInfo;
        cart.isDiliveryLast = true;
        localStorage.setItem("posDloInfo", JSON.stringify(posDloInfo));
      }
      data.orders.push(cart)
      // console.log(data);
      // return;
      removeStorageItem("SELL");
      // vẫn đơn hàng hiện tại
      this.SET_INFO_SELL(data);
      this.SET_RM_ID(0);
      this.$router.push("/pos");
    },
    async deleteItem(id) {
      // console.log("huy", id)
      if (id) {
        this.loading = true;
        try {
          let responseCancel;

          // đơn thường
          if (!this.isOrderFormOnlineStore) {
            const _paramsCancel = {
              id: id,
              reason: "",
            };
            responseCancel = await OrdersService.cancelItem(_paramsCancel);
          }

          // đơn từ gian hàng trực tuyến
          else {
            const _paramsCancel = {
              orderId: id,
            };
            responseCancel = await OrdersService.cancelItemStore(_paramsCancel);
            // console.log(123, responseCancel )
          }
          if (responseCancel.success) {
            this.fetchData();
            this.showSwalSuccess("Hủy đơn hàng");
            this.showOrderCancel = false;
          } else {
            this.showSwalError("Hủy đơn hàng", responseCancel.message);
          }
        } catch (error) {
          console.log(error);
          this.showNotify("Lỗi hủy đơn hàng", error, "error");
        } finally {
          this.loading = false;
        }
      }
    },
    continueOrder() {
      // đơn nháp bán tại quầy
      this.addItem();
    },
    async exportOrder({ isNotShowSuccess }) {
      // check đủ số lượng lô imei
      if (this.checkIsEnoughImeiAndProductBatch(this.lineItemMerge)) {
        // alert("ok")
        // return true
        const isConfirmCheckout = await this.confirmCheckout({ isNotShowSuccess });
        if (isConfirmCheckout) return true;
        else return false;
      } else {
        this.showExport = true;
        this.$refs.order_info.scrollIntoView({ behavior: "smooth", block: "center" });
        return false;
      }
    },

    // submit
    updateLineItem(data) {
      // console.log(22, data);
      this.lineItemMerge = {};
      this.lineItemMerge = data;
    },
    printBill() {
      this.clickOpenTypeShowModal = true;
    },

    async confirmPayment() {
      const id = this.itemId;
      if (id) {
        this.loading = true;
        try {
          const params = {
            id: id,
          };
          const response = await OrdersService.confirmPayment(params);
          // console.log(123, response )
          if (response.success) {
            // this.isPaying = true
            this.showConfirmPayment = false;
            this.showConfirmPaymentDLO = false;
            this.showSwalSuccess("Xác nhận thanh toán");
            this.fetchData();
          } else {
            this.showSwalError("Xác nhận thanh toán", response.message);
          }
        } catch (error) {
          console.log(error);
          this.showNotify("Lỗi xác nhận thanh toán", error, "error");
        } finally {
          this.loading = false;
        }
      }
    },
    async confirmCheckout({ isNotShowSuccess }) {
      return this.confirmCheckoutMixin({ isNotShowSuccess }, this.lineItemMerge, this.itemId);
    },

    ReturnAllItems() {
      this.ReturnAllItemsModal = true;
    },

    async confirmReturnItems() {
      this.loading = true;
      try {
        let responseCancel;
        if (!this.isOrderFormOnlineStore) {
          const _paramsCancel = {
            id: this.itemId,
            reason: "Hủy đơn hàng",
          };
          // console.log(_paramsCancel);
          // this.loading = false
          // return
          responseCancel = await OrdersService.cancelItem(_paramsCancel);
        }
        if (responseCancel.success) {
          this.fetchData();
          this.showSwalSuccess("Hủy đơn hàng");
          this.ReturnAllItemsModal = false;
        } else {
          this.showSwalError("Hủy đơn hàng", responseCancel.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi hủy đơn hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },

    // delivery
    async getListDLO() {
      try {
        const ids = this.orderData.deliveryData.params.deliveryHistory.map((e) => e.deliveryOrderId);
        // const ids = [1,2,3,4,5]
        const parmasIds = `['''${ids.join("''', '''")}''']`;
        // console.log(parmasIds);
        // return
        const params = {
          pageNum: 1,
          pageSize: 100,
          queryString: `{id} in ${parmasIds}`,
          sortBy: "createdAt",
          sortType: "ASC",
          textSearch: "",
        };
        const response = await OrdersService.getListDloByIds(params);
        // console.log(223, response);
        if (response.success) {
          const data = response.data.data || [];
          data.map((item) => {
            const DELIVERY_INFO = item.furtherInstructions.find((e) => e.key == "DELIVERY_INFO");
            // console.log(33, DELIVERY_INFO);
            item.checkoutAt = DELIVERY_INFO.params.checkoutAt || "";
            item.returnFee = DELIVERY_INFO.params.returnFee || 0;
          });
          // data.map((item) => {
          //   item.returnFee = 0;
          //   const result = this.orderData.deliveryData.params.deliveryHistory.filter((e) => e.deliveryOrderId == item.id);
          //   if (result.length) {
          //     result.forEach(e => {
          //       if(e.returnFee != null) {
          //         item.returnFee = e.returnFee ? e.returnFee : 0;
          //       }
          //     });
          //     // console.log(item,  this.orderData.deliveryData.params.deliveryHistory, result)
          //   }
          // });
          // console.log(data);
          this.listDLO = data;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getDLOinfor(id) {
      try {
        this.loading = true;
        const response = await OrdersService.getDloById(id);
        // console.log(223, response);
        if (response.success) {
          this.DLOinfo = response.data;
          if (this.DLOinfo.targetService == "DELIVERY_PARTNER") this.isDELIVERY_PARTNER = true;
          else this.isDELIVERY_PARTNER = false;

          if (this.DLOinfo.targetService == "DELIVERY_PARTNER" && this.DLOinfo.processorStatus == "NEW") {
            const DELIVERY_INFO = this.DLOinfo.furtherInstructions.find((e) => e.key == "DELIVERY_INFO");
            const DELIVERY_INFO_DATA = DELIVERY_INFO.params;
            this.isPushedToPartner = DELIVERY_INFO_DATA.isPushedToPartner ? DELIVERY_INFO_DATA.isPushedToPartner : false;
          }
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Có lỗi", error, "error");
      } finally {
        this.loading = false;
      }
    },
    getTypeShipper(type) {
      switch (type) {
        case "DELIVERY_PRIVATE_SHIPPER":
          return "Tự gọi shipper";
        case "DELIVERY_PARTNER":
          return "Shipper đối tác";

        default:
          return type;
      }
    },
    getPaymentsStatus(status) {
      switch (status) {
        case "UNPAID":
          return {
            status: "NEW",
            text: "Chưa thanh toán",
          };

        case "PAYING":
          return {
            status: "PROCESSING",
            text: "Chờ thanh toán",
          };
        case "PAID_IN_FULL":
          return {
            status: "COMPLETE",
            text: "Đã thanh toán",
          };

        default:
          return {
            status: status,
            text: "",
          };
      }
    },

    getDeliveryStatus,

    async deliveryToShipper({ isNotShowSuccess }) {
      // console.log(this.isExportOrder)
      if (this.isOrderFormOnlineStore && !this.isExportOrder) {
        this.loading = true;
        // console.log("ok");
        const isExportDone = await this.exportOrder({ isNotShowSuccess: true });
        if (!isExportDone) {
          this.loading = false;
          return false;
        }
      }
      // console.log("giao cho ship ne")
      // return
      this.loading = true;
      try {
        // const res = await OrdersService.deliveryToShipperApi(this.DLOid)
        const res = await OrdersService.deliveryToShipperApi({
          id: this.DLOid,
        });

        if (res.success) {
          if (isNotShowSuccess) {
            // await this.fetchData()
            return true;
          }
          this.showSwalSuccess("Xác nhận giao hàng cho shipper");
          this.fetchData();
          return true;
        } else {
          this.showSwalError("Giao hàng", res.message);
          return false;
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi giao hàng", error, "error");
        return false;
      } finally {
        this.loading = false;
      }
    },

    async deliveryToPartner({ isNotShowSuccess }) {
      //
      // console.log(1)
      // return
      if (this.isOrderFormOnlineStore && !this.isExportOrder) {
        this.loading = true;
        console.log("ok");
        const isExportDone = await this.exportOrder({ isNotShowSuccess: true });
        if (!isExportDone) {
          this.loading = false;
          return false;
        }
      }
      try {
        this.loading = true;
        // const res = await OrdersService.deliveryToShipperApi(this.DLOid)
        const res = await OrdersService.deliveryToPartnerApi({
          id: this.DLOid,
        });

        if (res.success) {
          if (isNotShowSuccess) {
            // await this.fetchData()
            return true;
          }
          this.showSwalSuccess("Xác nhận đã đẩy đơn qua hãng");
          this.fetchData();
          return true;
        } else {
          this.showSwalError("Giao hàng", res.message);
          return false;
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi giao hàng", error, "error");
        return false;
      } finally {
        this.loading = false;
      }
    },

    async confirmPaymentDLO() {
      if (!(this.CODpayment && this.CODpayment.params && this.CODpayment.params.amount != null)) {
        this.showSwalError("Không tìm thấy thông tin thanh toán COD");
        return;
      }
      const CODlist = this.orderData.outcomes.filter((e) => e.key == "COD_NEXT_SHOP" && e.params && e.params.status == "PROCESSING");
      if (CODlist && CODlist.length) {
        this.loading = true;
        const request = CODlist.map((item) => {
          const params = {
            orderId: this.itemId,
            paymentInfo: {
              outcomeId: item.outcomeId,
              amount: item.params.amount,
              note: item.note,
              paymentMethod: item.params.payMethod,
              paymentGateway: item.params.payGateway,
              status: "SUCCESS",
            },
          };
          return OrdersService.recordPayment(params);
        });
        this.loading = true;
        Promise.all(request)
          .then((res) => {
            this.showConfirmPaymentDLO = false;
            this.showSwalSuccess("Xác nhận thanh toán", res.message);
            this.fetchData();
          })
          .catch((error) => {
            console.log(error);
            this.showNotify("Lỗi thanh toán", error, "error");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    async deliveryAllDone() {
      // console.log(123);
      // return
      this.loading = true;
      const isDeliveryToShipper = await this.deliveryToShipper({ isNotShowSuccess: true });
      if (!isDeliveryToShipper) {
        this.loading = false;
        return;
      }
      await this.deliveryDone();
      this.showDeliveryAllDone = false;
    },

    async deliveryDone() {
      const dloId = this.orderData.deliveryHistoryLast.deliveryOrderId;
      const params = {
        orderId: dloId,
        newStatus: "COMPLETE", // trạng thái mới:  COMPLETE hoặc FAILED
        isCancelSO: false, // nếu cập nhập DLO FAILED và muốn hủy luôn so -> truyền true
        returnFee: 0,
      };
      this.loading = true;
      try {
        const res = await OrdersService.updateStatusByMerchant(params);
        if (res.success) {
          this.showSwalSuccess("Giao hàng");
          this.showDeliveryDone = false;
          this.fetchData();
        } else {
          this.showSwalError("Giao hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi giao hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },

    async confirmCancelAll() {
      const params = {
        orderId: this.DLOid,
        newStatus: "FAILED", // trạng thái mới:  COMPLETE hoặc FAILED
        isCancelSO: true, // nếu cập nhập DLO FAILED và muốn hủy luôn so -> truyền true
        returnFee: this.feeDLO * 1000,
      };
      this.loading = true;
      // console.log(params);
      // return
      try {
        const res = await OrdersService.updateStatusByMerchant(params);
        if (res.success) {
          this.fetchData();
          this.showSwalSuccess("Hủy đơn hàng");
          this.showPopupCancelAll = false;
        } else {
          this.showSwalError("Hủy đơn hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi hủy đơn hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },

    async confirmCancelAllPartner() {
      const params = {
        keepSO: false,
        orderId: this.DLOid,
        reason: "",
      };
      // console.log(params);
      // return
      try {
        this.loading = true;
        const res = await OrdersService.cancelBeforeConfirm(params);
        if (res.success) {
          this.fetchData();
          this.showSwalSuccess("Hủy đơn hàng");
          this.showPopupCancelAllPartner = false;
        } else {
          this.showSwalError("Hủy đơn hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showSwalError("Hủy đơn hàng");
      } finally {
        this.loading = false;
      }
    },

    async handleOrderDLOCancelAndDoNothing(DLOid) {
      this.loading = true;
      const params = {
        // "nshOrderId": DLOid,   // id đơn DLO
        // "partnerType": "OUTSIDE_SHIPPER_TYPE",      // OUTSIDE_SHIPPER_TYPE nếu là ship ngoài
        // "reason": ""
        orderId: DLOid,
        reason: "",
      };
      // console.log(params)
      // return
      try {
        const res = await OrdersService.cancelBeforeConfirm(params);
        if (res.success) {
          this.showOrderDLOCancelAndDoNothing = false;
          this.fetchData();
          this.showSwalSuccess("Hủy đơn hàng");
        } else {
          this.showSwalError("Hủy giao hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi hủy giao hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },

    async confirmCancelDloGHTT() {
      this.loading = true;
      const params = {
        // "nshOrderId": this.DLOid,   // id đơn DLO
        // "partnerType": "OUTSIDE_SHIPPER_TYPE",      // OUTSIDE_SHIPPER_TYPE nếu là ship ngoài
        // "reason": "",
        keepSO: true,
        orderId: this.DLOid,
        reason: "",
      };
      try {
        const res = await OrdersService.cancelBeforeConfirm(params);
        if (res.success) {
          this.showSwalSuccess("Hủy giao hàng");
          this.showPopupCancelDloGHTT = false;
          this.fetchData();
        } else {
          this.showSwalError("Hủy giao hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi hủy đơn hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },

    async confirmCancelAndRenew() {
      // tét
      // await this.createNewDeliveryForSO()
      // return

      const params = {
        orderId: this.DLOid,
        newStatus: "FAILED", // trạng thái mới:  COMPLETE hoặc FAILED
        isCancelSO: false, // nếu cập nhập DLO FAILED và muốn hủy luôn so -> truyền true
        returnFee: this.feeDLO * 1000,
      };
      try {
        this.loading = true;
        const res = await OrdersService.updateStatusByMerchant(params); // check lai
        if (res.success) {
          this.showPopupCancelAndRenew = false;
          this.showSwalSuccess("Hủy đơn hàng");
          await this.fetchData();
          // asdas
          this.handleCreateNewDlo();
        } else {
          this.showSwalError("Hủy đơn hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi hủy đơn hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },
    checkOderFromPartner(key) {
      if (this.isDELIVERY_PARTNER && this.orderData.deliveryData.params.deliveryStatus == "PROCESSING") {
        this.showIsNotCancel = true;
        return;
      } else {
        this[key] = true;
      }
    },

    async confirmCancelAndRenewPartner() {
      const params = {
        keepSO: true,
        orderId: this.DLOid,
        reason: "",
      };
      // console.log(params)
      // return
      try {
        this.loading = true;
        const res = await OrdersService.cancelBeforeConfirm(params); // check lai
        if (res.success) {
          this.showPopupCancelAndRenewPartner = false;
          this.showSwalSuccess("Hủy đơn hàng");
          await this.fetchData();
          // asdas
          this.handleCreateNewDlo();
        } else {
          this.showSwalError("Hủy đơn hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi hủy đơn hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },

    getParamsDlo(posDloInfo) {
      posDloInfo.deliveryServicePack = posDloInfo.deliveryServicePack.packageInfo.id ? posDloInfo.deliveryServicePack : null;
      posDloInfo.soOrderId = this.itemId;
      return posDloInfo;
    },

    async updateDLO(posDloInfo) {
      if (this.orderData.deliveryData.params.deliveryStatus == "FAILED" || this.orderData.deliveryData.params.deliveryStatus == "CANCEL") {
        // tao don gioa hang moi
        // return
        this.createNewDeliveryForSO(posDloInfo);
        return;
      }
      // sua don giao hang hien tai
      this.loading = true;
      try {
        const params = _.cloneDeep(posDloInfo);
        delete params.pickUpAddress;
        delete params.addFeesShipping;
        params.deliveryServicePack = posDloInfo.deliveryServicePack.packageInfo.id ? posDloInfo.deliveryServicePack : null;
        params.orderId = this.DLOid;
        // console.log(123, {posDloInfo, params})
        // return

        const res = await OrdersService.updateInforDLO(params);
        if (res.success) {
          this.showSwalSuccess("Sửa thông tin giao hàng");
          this.showDeliveryModal = false;
          this.fetchData();
          this.loading = false;
        }
      } catch (error) {
        this.showNotify("Lỗi sửa thông tin giao hàng", error, "error");
        this.loading = false;
        console.log(error);
      }
    },

    async changeDLOinfoDone(dloInfo) {
      // console.log(111 ,dloInfo)
      const newDloInfoConverted = this.convertDataFromDLOform(dloInfo);
      await this.updateDLO(newDloInfoConverted);
    },

    async changeDLOinfo() {
      // SỬA THÔNG TIN SỬ DỤNG COMPONENT DELIVERY
      this.loading = true;
      this.dloInfoTmp = null
      const posDloInfo = await this.getPosDloInfo(this.DLOinfo, this.getFeeShip(this.orderData)); // test
      this.dloInfoTmp = _.cloneDeep(posDloInfo)
      // console.log(123, posDloInfo, this.DLOinfo)
      // return
      // await setStorageItem("posDloInfoDetail", JSON.stringify(posDloInfo));
      this.showDeliveryModal = true;
      this.loading = false;
    },

    getFeeShip(orderData) {
      const fee = orderData.lineItemFinalizing.addedFee.find((e) => e.key == "SHIPPING_FEE");
      return fee ? fee.amount / 1000 : 0;
    },

    handleCreateNewDlo() {
      this.changeDLOinfo();
    },
    async createNewDlo(dloData) {
      // console.log(12333, dloData);
      const newDloInfoConverted = this.convertDataFromDLOform(dloData);
      await this.createNewDeliveryForSO(newDloInfoConverted);
    },
    async handleCreateNewDloFromGHTT() {
      // tự fill khách hàng
      // SỬA THÔNG TIN SỬ DỤNG COMPONENT DELIVERY
      this.loading = true;
      const { city = null, district = null, village = null } = this.orderData.partyB.otherInfo;
      const address = await getAllAddressName(city, district, village);

      const newPosDloInfo = _.cloneDeep(dloInfoPos);
      // console.log(333, newPosDloInfo);
      // return
      newPosDloInfo.shippingAddress = {
        ...newPosDloInfo.shippingAddress,
        address: this.orderData.partyB.address,
        city: city ? city : null,
        cityName: address.cityName,
        district: district ? district : null,
        districtName: address.districtName,
        village: village ? village : null,
        villageName: address.wardName,
        phoneNo: this.orderData.partyB.phoneNo,
        receiverId: this.orderData.partyB.resId,
        receiverName: this.orderData.partyB.displayName,
      };
      // posDloInfo.pickUpAddress = { ...posDloInfo.pickUpAddress, ...(await this.getInitDataPickUpAddress()) };
      // await setStorageItem("posDloInfoDetail", JSON.stringify(newPosDloInfo));
      this.dloInfoTmp = null
      this.dloInfoTmp = newPosDloInfo
      this.showDeliveryModal = true;
      this.loading = false;
    },

    async createNewDeliveryForSO(posDloInfo) {
      const params = _.cloneDeep(posDloInfo);
      params.deliveryServicePack = posDloInfo.deliveryServicePack.packageInfo.id ? posDloInfo.deliveryServicePack : null;
      params.soOrderId = this.itemId;
      delete params.addFeesShipping;
      // console.log(params)
      // return
      try {
        this.loading = true;
        const res = await OrdersService.createNewDelivery(params); // check lai
        if (res.success) {
          this.fetchData();
          this.showSwalSuccess("Tạo đơn giao hàng");
          this.showDeliveryModal = false;
        } else {
          this.showSwalError("Tạo đơn giao hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showNotify("Lỗi tạo đơn giao hàng", error, "error");
      } finally {
        this.loading = false;
      }
    },
    clickToDLO(item) {
      this.$router.push({ path: `/orders-delivery/delivery-order-detail/${item.id}` });
    },

    handleShowConfirmPayment() {
      if (this.isOrderFormOnlineStore) {
        this.showConfirmPayment = true;
        return;
      }
      if (!this.isOrderFormOnlineStore && this.isDLO) {
        this.showConfirmPaymentDLO = true;
        return;
      }
    },
  },
  filters: {
    formatInformation(value) {
      return value ? value : "---";
    },
    formatPercent(value) {
      return Math.floor(+value * 100);
    },
  },
  computed: {
    isPayed() {
      if (!this.orderData || !this.orderData.outcomes) return false;
      const payInfor = this.orderData.outcomes.find((e) => e.cat === "NSH_PAYMENT");
      return payInfor && payInfor.params && payInfor.params.status && payInfor.params.status === "SUCCESS" ? true : false;
    },
    isPayedAPart() {
      if (!this.orderData || !this.orderData.outcomes) return false;
      const payInfor = this.orderData.outcomes.find((e) => e && e.cat === "NSH_PAYMENT" && e.params && e.params.status === "SUCCESS");
      return payInfor ? true : false;
    },
    isExportOrder() {
      if (!this.orderData || !this.orderData.outcomes) return false;
      const exportInfor = this.orderData.outcomes.find((e) => e.cat === "NSH_CHECKOUT");
      return exportInfor && exportInfor.params ? true : false;
    },
    isSOFromReturn() {
      if (!this.orderData || !this.orderData.outcomes) return false;
      const SO = this.orderData.furtherInstructions.find((e) => e.params && e.params.sourceAction && e.params.sourceAction == "RETURN");
      if (SO) return true;
      else return false;
    },
    CODpayment() {
      if (!this.orderData || !this.orderData.outcomes) return null;
      return this.orderData.outcomes.find((e) => e.key == "COD_NEXT_SHOP");
    },
    isNotCODpayment() {
      return (this.CODpayment && this.CODpayment.params && this.CODpayment.params.status == "PROCESSING") || false;
    },
    CODmoney() {
      return this.CODpayment && this.CODpayment.params && this.CODpayment.params.amount ? +this.CODpayment.params.amount : 0;
    },
    moneyPayed() {
      if (this.orderData && this.orderData.outcomes) {
        const payInfor = this.orderData.outcomes.filter((e) => e.cat === "NSH_PAYMENT" && e.params && e.params.status == "SUCCESS");
        let totalAmount = 0;
        payInfor.map((e) => {
          if (e.params && e.params.amount) {
            totalAmount += +e.params.amount;
          }
        });
        return totalAmount;
      }
      return 0;
    },
    isOrderOnlineHasDlo() {
      return (
        this.isDLO &&
        this.orderData.deliveryData.params.deliveryStatus !== undefined &&
        this.orderData.deliveryData.params.deliveryStatus !== "CANCEL" &&
        this.orderData.deliveryData.params.deliveryStatus !== "FAILED"
      );
    },
    DELIVERY_INFO_DATA() {
      if (this.DLOinfo && this.DLOinfo.furtherInstructions) {
        const DELIVERY_INFO = this.DLOinfo.furtherInstructions.find((e) => e.key == "DELIVERY_INFO");
        return DELIVERY_INFO.params;
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.pos-detail {
  font-size: 14px;
  color: #23313e;
  &_body {
    margin-top: 78px;
    margin-bottom: 150px;
  }
  .form-card_title {
    font-size: 20px;
    line-height: 20px;
    font-weight: 600;
  }
  .border-bottom {
    border-bottom: 1px solid #ddd;
  }
  .top-steps {
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 180px;
    padding-right: 180px;
  }
  .custom-alert {
    border-color: #ffc043;
    background-color: #fff9ec;
  }
}
</style>

<style lang="scss">
$dark: #23313e;
.pos-detail {
  .el-tabs__item {
    font-size: 20px;
    font-weight: 600;
    color: #ddd;
  }
  .el-tabs__item.is-active {
    color: #23313e;
  }
  .el-step__icon.is-text,
  .is-icon {
    width: 48px;
    height: 48px;
    font-size: 22px;
  }
  .el-step__line {
    display: none;
  }
  .el-step__head.is-wait {
    color: #23313e;
    border-color: #c0c4cc;
    .el-step__icon.is-text {
      background-color: #c0c4cc;
    }
  }
  .cancel .el-step__icon.is-text {
    // border: 1px solid #f62727;
    background-color: #f62727;
  }
  // .el-step__icon-inner {
  //   position: relative;
  // }
  // .cancel .el-step__icon-inner::after {
  //   display: block;
  //   position: absolute;
  //   left: 50%;
  //   top: 50%;
  //   transform: translate(-50%, -50%);

  //   content: "\00d7";
  //   color: red;
  //   font-weight: 100;
  //   font-size: 36px;
  //   line-height: 36px;
  // }
  table {
    margin-top: 26px;
  }
}
.custom-alert {
  border-color: #ffc043;
  background-color: #fff9ec;
  word-break: normal !important;
}
.popup-pos-detail_custom {
  .el-dialog__header {
    background-color: white;
  }
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.text-right {
  input {
    text-align: right;
  }
}
</style>
